var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$getTextSetting('template_version') === 2)?_c('section',[_c('IndexNew')],1):_c('section',[_c('IndexOld')],1)}
var staticRenderFns = []

export { render, staticRenderFns }